import { useState } from 'react';

import {
  AGENT_MENTION_TRIGGER,
  getPromptMentionState,
  type MentionState,
} from 'features/chat/utils/prompt-mention';

const CLOSED: MentionState = { active: false, query: '', startIndex: -1 };

type UseAgentMentionOptions = {
  enabled: boolean;
  onAgentChange?: (agentId: string | null, draftText: string) => void;
  onMessageChange: (message: string) => void;
};

/** Tracks `@query` in the chat input and switches the chat's agent when one is picked. */
export function useAgentMention({ enabled, onAgentChange, onMessageChange }: UseAgentMentionOptions) {
  const [agentMention, setAgentMention] = useState<MentionState>(CLOSED);

  const updateAgentMention = (text: string, cursor: number) => {
    setAgentMention(enabled ? getPromptMentionState(text, cursor, AGENT_MENTION_TRIGGER) : CLOSED);
  };

  const closeAgentMention = () => setAgentMention(CLOSED);

  const selectAgentMention = (message: string, agentId: string) => {
    const { startIndex, query } = agentMention;
    const draft =
      startIndex < 0
        ? message
        : message.slice(0, startIndex) + message.slice(startIndex + 1 + query.length);
    setAgentMention(CLOSED);
    onMessageChange(draft);
    onAgentChange?.(agentId, draft.trim() ? draft : '');
  };

  return { agentMention, updateAgentMention, closeAgentMention, selectAgentMention };
}
